'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'binary';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e33b';
var svgPathData = 'M232 0l-8 0 0 16 8 0 64 0 0 192-64 0-8 0 0 16 8 0 72 0 72 0 8 0 0-16-8 0-64 0L312 8l0-8-8 0L232 0zM8 288l-8 0 0 16 8 0 64 0 0 192L8 496l-8 0 0 16 8 0 72 0 72 0 8 0 0-16-8 0-64 0 0-200 0-8-8 0L8 288zM16 0l0 8 0 208 0 8 8 0 144 0 8 0 0-8L176 8l0-8-8 0L24 0 16 0zM32 16l128 0 0 192L32 208 32 16zM216 288l-8 0 0 8 0 208 0 8 8 0 144 0 8 0 0-8 0-208 0-8-8 0-144 0zm8 208l0-192 128 0 0 192-128 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBinary = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;